<script setup>
import {
  Refresh,
  ZoomOut,
  ZoomIn,
  RefreshLeft,
  RefreshRight,
  Back,
  Right
} from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import { onBeforeMount, onMounted, ref } from 'vue'

const props = defineProps({
  data: {
    type: Array,
    default: () => []
  },
  index: {
    type: Number,
    default: 0
  },
  type: {
    type: String,
    default: 'image'
  }
})
const emits = defineEmits(['close'])
const preIndex = ref(0)
preIndex.value = props.index
const scale = ref(1)
const rotate = ref(0)

const prev = () => {
  if (preIndex.value !== 0) {
    preIndex.value--
  }
}
const next = () => {
  if (preIndex.value < props.data.length - 1) {
    preIndex.value++
  }
}
const zoomOut = () => {
  scale.value = (scale.value * 2) / 3
}
const zoomIn = () => {
  scale.value = (scale.value * 3) / 2
}
const zoom = (e) => {
  if (e.deltaY < 0) {
    zoomIn()
  } else if (e.deltaY > 0) {
    zoomOut()
  }
}
const clockwise = () => {
  rotate.value -= 90
}
const counterclockwise = () => {
  rotate.value += 90
}
const refresh = () => {
  scale.value = 1
  rotate.value = 0
}
const keyEvent = (event) => {
  switch (event.key) {
    case 'ArrowLeft':
      prev()
      break
    case 'ArrowRight':
      next()
      break
  }
}
onMounted(() => {
  window.addEventListener('keydown', keyEvent)
})
onBeforeMount(() => {
  window.removeEventListener('keydown', keyEvent)
})
</script>

<template>
  <div class="el-image-viewer__wrapper" style="z-index: 9999" @click="emits('close')" @wheel="zoom">
    <div class="el-image-viewer__mask"></div>
    <div class="el-image-viewer__btn el-image-viewer__progress"
      >{{ preIndex + 1 }} / {{ props.data.length }}
    </div>
    <div class="el-image-viewer__btn el-image-viewer__actions" style="width: 350px" @click.stop="">
      <div class="el-image-viewer__actions__inner">
        <el-icon @click.stop="prev">
          <Back />
        </el-icon>
        <el-icon @click.stop="next">
          <Right />
        </el-icon>
        <el-icon>
          <ZoomOut @click.stop="zoomOut" />
        </el-icon>
        <el-icon>
          <ZoomIn @click.stop="zoomIn" />
        </el-icon>
        <el-icon>
          <RefreshLeft @click.stop="clockwise" />
        </el-icon>
        <el-icon>
          <RefreshRight @click.stop="counterclockwise" />
        </el-icon>
        <el-icon>
          <Refresh @click.stop="refresh" />
        </el-icon>
      </div>
    </div>
    <div class="el-image-viewer__canvas" @click.stop="">
      <img
        v-if="type === 'image'"
        :src="data[preIndex]"
        class="el-image-viewer__img"
        style="max-height: 100%; max-width: 100%"
        :style="{ transform: `scale(${scale}) rotate(${rotate}deg)` }"
        alt=""
      />
      <video
        v-if="type === 'video'"
        controls="true"
        autoplay="true"
        :src="data[preIndex]"
        class="el-image-viewer__img"
        style="max-height: 100%; max-width: 100%"
        :style="{ transform: `scale(${scale}) rotate(${rotate}deg)` }"
      ></video>
    </div>
  </div>
</template>

<style scoped>
.el-image-viewer__progress {
  left: 50%;
  transform: translate(-50%);
  cursor: default;
  color: #fff;
  bottom: 90px;
}
</style>
